import React from "react";

/**
 * TabContent component for rendering tab content wrapper
 * @author Muskan Thakur
 */
const TabContent = ({ children, containerRef }) => {
  return (
    <div className='dt-editor-users overflow-auto overflow-x-hidden w-100' ref={containerRef}>
      {children}
    </div>
  );
};

export default React.memo(TabContent);
